const UBIQUITOUS_CONSTANTS = {
  MISSION: "콘텐츠",
  EVENT: "캠페인",
} as const;

export default UBIQUITOUS_CONSTANTS;
